interface Item<T extends string> {
  id: T;
  label: string;
}

interface Props<T extends string> {
  items: ReadonlyArray<Item<T>>;
  value: T;
  onChange: (next: T) => void;
  ariaLabel?: string;
}

export function Segmented<T extends string>({ items, value, onChange, ariaLabel }: Props<T>) {
  return (
    <div className="segmented" role="radiogroup" aria-label={ariaLabel}>
      {items.map((it) => (
        <button
          key={it.id}
          type="button"
          role="radio"
          aria-checked={value === it.id}
          className={value === it.id ? 'active' : ''}
          onClick={() => onChange(it.id)}
        >
          {it.label}
        </button>
      ))}
    </div>
  );
}
